import type { Duration, PricingOffer } from "@/lib/pricing";
import { request } from "./transport";

export interface CheckoutSessionInput {
  duration: Duration;
  email?: string;
  ref?: string;
  locale?: "en" | "zh";
}

export interface CheckoutSession {
  readonly id: string;
  readonly url: string;
}

export const stripe = {
  createCheckoutSession: (input: CheckoutSessionInput) =>
    request<CheckoutSession>("/stripe/checkout", {
      method: "POST",
      body: JSON.stringify(input),
    }),
  getPricing: () => request<PricingOffer>("/stripe/pricing"),
  createPortalSession: () =>
    request<{ readonly url: string }>("/stripe/portal", { method: "POST" }),
};
